//@ts-nocheck
import { useState, useEffect } from 'react';
import type { NextPage } from 'next';
import Link from 'next/link';
import Image from 'next/image';
import Layout from '@components/Layout';
import {
  GlobalStyle,
  BlogSection,
  ArticleWrap,
  BlogWrapContent,
  MenuWrap
} from '@components/Fblog.styles';
import { LogoWhite } from '@assets/svgs';
import Menu from '@components/Menu/index';
import Footer from '@components/Footer';
import Cover_2_Alignment3 from '@assets/Cover_2_Alignment3.png';

const Events: NextPage = () => {
  const [scroll, setScroll] = useState(false);
  const [gapC] = useState('15px');

  useEffect(() => {
    window.addEventListener('scroll', () => {
      setScroll(window.scrollY > 100);
    });
  }, []);

  return (
    <>
      <GlobalStyle />
      <Layout
        showHeader
        showCopyheader
        animationHeader="header"
        showFashionDesktop
        showMenu
        color="#000"
        logo={<LogoWhite />}
      >
        <BlogSection>
          <ArticleWrap>
            <div className={scroll ? 'onScrollBottomMenu' : 'onScrollTopMenu'}>
              <h1>Events & Galas.</h1>
              <MenuWrap>
                <Menu showCopywritingMenu />
              </MenuWrap>
            </div>

            <BlogWrapContent>
              <Image
                src={Cover_2_Alignment3}
                width={600}
                height={1024}
                alt="Ward 4"
                style={{ maxWidth: '100%' }}
              />
              <br />
              <br />
              <p style={{ width: '100%' }}>
                The Martin’s House completely rejects the passive,
                template-driven formats of traditional corporate seminars,
                panels, or industry conventions. Our gatherings are highly
                exclusive, low-frequency tactical enclaves and opulent black-tie
                galas engineered strictly for the global ruling class.
                <br />
                <br />
                Every gathering is executed within an air-gapped,
                signal-shielded environment to guarantee absolute data
                sovereignty, transaction privacy, and structural security for
                our members. We do not gather merely to network; we gather to
                celebrate absolute vertical dominance, review cross-border asset
                calculus, and lock in high-stakes corporate alignments away from
                public scrutiny.
                <br />
                <br />
                1- <b>The Sovereign Contract Briefings:</b> Restricted
                roundtable panels co-chaired alongside our lead brand strategy
                advisor, George Martins, designed to interrogate why specific
                visual and strategic signals command absolute legitimacy and
                vertical desire in the international arena.
                <br />
                <br />
                <b>2- The Identity Alignment Summits:</b> A forensic masterclass
                led by our material specialists deconstructing the physical
                infrastructure of executive command, auditing everything from
                footwear biomechanics and horological synchronisation to
                olfactory boundary design.
                <br />
                <br />
                <b>3- The Imperial House Galas:</b> High-velocity, black-tie
                evening galas hosted across legendary global enclaves (New York,
                London, Tokyo) matching our lifestyle indices. These majestic
                environments serve as the ultimate celebration of high-agency
                authority, where our members step onto the floor in perfect
                Daniell London Evening Sandal Heels, showcasing absolute
                elegance and unbending posture in a room full of competitive
                global leaders.
              </p>
            </BlogWrapContent>
          </ArticleWrap>
          <Footer isClass="footer" />
        </BlogSection>
      </Layout>
    </>
  );
};

export default Events;
